import { Directive, ElementRef, Input } from '@angular/core';

/**
 * 뇌 이미지에 clip 효과를 주어서 그래프 효과를 냄
 * 하단을 기준으로 상단이 줄어들어야 하므로 clip: rect() 의 top 값을 이미지 높이의 역 %만큼 지정
 */
@Directive({
  selector: '[graph-percent]',
})
export class GraphPercent {
  private $el: HTMLElement;
  private percent: number;

  constructor(el: ElementRef) {
    this.$el = el.nativeElement;
  }

  @Input('graph-percent') set graphPercent(percent: number) {
    setTimeout(
      () => {
        const top = this.$el.offsetHeight * (100 - percent) / 100 + 'px';
        const bottom = '9999px';
        const left = '0';
        const right = '9999px';
        this.percent = percent;
        this.$el.style.clip = `rect(${top} ${right} ${bottom} ${left})`;
      },
      0);
  }
}
